import { debounce } from '../../helpers';

let observer;

const scrollObserver = () => {
  const header = document.querySelector('.header');
  const h = header ? header.clientHeight * 0.5 : 0;
  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            header.classList.add('header_dark');
          }, 0);
        } else {
          header.classList.remove('header_dark');
        }
      });
    },
    {
      rootMargin: `-${h}px 0px -${window.innerHeight - h}px`,
    },
  );
  document.body
    .querySelectorAll('.bg-white:not(.header-popup-menu):not(.contact-form-popup)')
    .forEach(el => observer.observe(el));
};

const onResize = debounce(scrollObserver, 200);

export default scrollObserver;

window.addEventListener('resize', onResize);
window.addEventListener('orientationchange', onResize);
